/** Mirrors the server's `lkpAuthenticationType`, sent as `authenticationTypeL` by the email check. */
export enum AuthenticationType {
  Email = 0,
  CitadelActiveDirectory = 1,
  BSolveActiveDirectory = 2,
  EmailOtp = 3,
  ImpersonationOnly = 4,
}
